export const valiateImportForm = (formValues, selTrainer) => {
  let errors = {};

  if (!selTrainer) {
    errors.selTrainer = "Select Trainer!";
  }

  formValues.forEach((formValue, index) => {
    Object.entries(formValue).forEach(([key, value]) => {
      if (
        ["choosedFile", "convertedFile", "endDate", "taxAmount"].includes(key)
      ) {
        return;
      }

      if (!value) {
        if (!errors[index]) {
          errors[index] = {};
        }
        errors[index][key] = `${key} is required!`;
      } else if (key === "memMobile" && !/^\d{10}$/.test(value)) {
        if (!errors[index]) {
          errors[index] = {};
        }
        errors[index][key] = "Invalid mobile number!";
      } else if (key === "memEmail" && !/\S+@\S+\.\S+/.test(value)) {
        if (!errors[index]) {
          errors[index] = {};
        }
        errors[index][key] = "Invalid email address!";
      } else if (key === "memEmail" && value.endsWith("@yopmail.com")) {
        if (!errors[index]) {
          errors[index] = {};
        }
        errors[index][key] = "Email from YOPmail is not allowed!";
      }
    });
  });

  // formValues.forEach((formValue, index) => {
  //   Object.entries(formValue).forEach(([key, value]) => {
  //     if (!value && key !== "endDate" && key !== "taxAmount") {
  //       if (!errors[index]) {
  //         errors[index] = {};
  //       }
  //       errors[index][key] = `${key} is required!`;
  //     } else if (key === "memMobile" && !/^\d{10}$/.test(value)) {
  //       if (!errors[index]) {
  //         errors[index] = {};
  //       }
  //       errors[index][key] = "Invalid mobile number!";
  //     } else if (key === "memEmail" && !/\S+@\S+\.\S+/.test(value)) {
  //       if (!errors[index]) {
  //         errors[index] = {};
  //       }
  //       errors[index][key] = "Invalid email address!";
  //     } else if (key === "memEmail" && value.endsWith("@yopmail.com")) {
  //       if (!errors[index]) {
  //         errors[index] = {};
  //       }
  //       errors[index][key] = "Email from YOPmail is not allowed!";
  //     } else if (key === "endDate" || key === "taxAmount") {
  //       return;
  //     }
  //   });
  // });

  return errors;
};
